import { apiRequest } from './httpClient';

export async function fetchAdminClientsSnapshot() {
  return apiRequest('getAdminClientsSnapshot', {
    method: 'GET',
    requireAuth: true,
  });
}

export async function upsertClientRecord({ clientId, payload, sendAccessLink = true }) {
  return apiRequest('upsertClientRecord', {
    method: 'POST',
    body: {
      clientId,
      payload,
      sendAccessLink,
    },
    requireAuth: true,
  });
}

export async function deleteClientRecord({ clientId, email }) {
  return apiRequest('deleteClientRecord', {
    method: 'POST',
    body: {
      clientId,
      email,
    },
    requireAuth: true,
  });
}

export async function setClientStatus({ clientId, status }) {
  return apiRequest('setClientStatus', {
    method: 'POST',
    body: {
      clientId,
      status,
    },
    requireAuth: true,
  });
}

export async function sendClientAccessLink({ email, clientName }) {
  return apiRequest('sendClientAccessLink', {
    method: 'POST',
    body: {
      email,
      clientName,
    },
    requireAuth: true,
  });
}

export async function getClientMonthlyService(clientId) {
  return apiRequest('getClientMonthlyService', {
    method: 'GET',
    query: { clientId },
    requireAuth: true,
  });
}

export async function saveClientMonthlyService({ clientId, monthlyService }) {
  return apiRequest('saveClientMonthlyService', {
    method: 'POST',
    body: { clientId, monthlyService },
    requireAuth: true,
  });
}

export async function sendClientMonthlyAgreement(clientId) {
  return apiRequest('sendClientMonthlyAgreement', { method: 'POST', body: { clientId }, requireAuth: true });
}

// Útil para acuerdos firmados antes de activar el ciclo automático y para
// comprobar una cuenta puntual sin esperar el cron de la mañana.
export async function syncClientMonthlyServiceInvoice(clientId) {
  return apiRequest('syncClientMonthlyServiceInvoice', { method: 'POST', body: { clientId }, requireAuth: true });
}
